import React, { useState, useEffect } from "react";
import moment from "moment";
import _ from "lodash";
import Input from "./Input";
import Pagination from "./Pagination";
import { getLoggedInHistory } from "../services/soar";
import { paginate } from "../../scripts/helperScripts";
import Select from "./Select";
import LoginHistoryTable from "./LoginHistoryTable";

function LoginHistory() {
  const [selectedConnection, setSelectedConnection] = useState();
  const [beginDate, setBeginDate] = useState();
  const [endDate, setEndDate] = useState();
  const [searchQuery, setSearchQuery] = useState();
  const [loginHistory, setLoginHistory] = useState([]);
  const [totalCount, setTotalCount] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [sortColumn, setSortColumn] = useState({
    path: "LogCreatedEst",
    order: "desc",
  });
  const pageSize = 10;

  const loadLoginHistory = () => {
    getLoggedInHistory(selectedConnection, beginDate, endDate).then(
      (response) => {
        if (response) setLoginHistory(response.History);
        else setLoginHistory([]);
      }
    );
  };

  const getPagedData = () => {
    let loginHistorySearch = loginHistory;
    if (searchQuery) {
      loginHistorySearch = loginHistory.filter(
        (login) =>
          (login.DisplayName &&
            login.DisplayName.toLowerCase().includes(
              searchQuery.toLowerCase()
            )) ||
          login.BusinessUnitName.toLowerCase().includes(
            searchQuery.toLowerCase()
          ) ||
          login.SiteUrl.toLowerCase().includes(searchQuery.toLowerCase())
      );
    }
    const sorted = _.orderBy(
      loginHistorySearch,
      [sortColumn.path],
      [sortColumn.order]
    );

    if (totalCount !== sorted.length) setTotalCount(sorted.length);

    const history = paginate(sorted, currentPage, pageSize);
    return history;
  };

  useEffect(() => {
    setTotalCount(loginHistory.length);
  }, [loginHistory]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleSort = (sortColumn) => {
    setSortColumn(sortColumn);
  };

  return (
    <>
      <div className="container">
        <div className="row">
          <div className="col">
            <Select
              name="Connection"
              label="Connection"
              value={selectedConnection}
              options={[
                { _id: "safyportaltest", name: "Test" },
                { _id: "safyportal", name: "Production" },
              ]}
              onChange={(e) => {
                setSelectedConnection(e.currentTarget.value);
              }}
            />
          </div>
          <div className="col">
            <Input
              name="beginDate"
              label="Begin Date"
              type="date"
              value={beginDate}
              onChange={(e) => {
                setBeginDate(e.currentTarget.value);
              }}
            />
          </div>
          <div className="col">
            <Input
              name="endDate"
              label="End Date"
              type="date"
              value={endDate}
              onChange={(e) => {
                setEndDate(e.currentTarget.value);
              }}
            />
          </div>
          <div className="col">
            <button
              style={{ marginTop: "30px" }}
              className="btn btn-primary"
              onClick={loadLoginHistory}
              disabled={
                selectedConnection === undefined ||
                selectedConnection === "" ||
                beginDate === undefined ||
                beginDate === "" ||
                endDate === undefined ||
                endDate === ""
              }
            >
              View Report
            </button>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <Input
              name="searchQuery"
              label="Search"
              value={searchQuery}
              onChange={(e) => {
                setSearchQuery(e.currentTarget.value);
              }}
            />
          </div>
          <div className="col">
            <i
              style={{ marginTop: "35px" }}
              className="fas fa-window-close fa-2x text-danger float-start"
              onClick={() => {
                setSearchQuery("");
              }}
            ></i>
          </div>
          <div className="col"></div>
          <div className="col"></div>
        </div>
      </div>
      <LoginHistoryTable
        loginHistory={getPagedData()}
        sortColumn={sortColumn}
        onSort={handleSort}
      />
      <div className="row justify-content-center">
        <Pagination
          itemsCount={totalCount}
          pageSize={pageSize}
          currentPage={currentPage}
          onPageChange={handlePageChange}
        />
      </div>
    </>
  );
}

export default LoginHistory;
